export default __webpack_public_path__ + "static/phil-fbd5c4b4252c61d9a7bb15f079663e37.png";